import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { usePagination, DOTS } from '../../hooks/usePagination';

const PaginationNav = ({ selected, setSelected, totalPages, pageSize = 10 }) => {
  const paginationRange = usePagination({
    currentPage: selected,
    totalPages,
    pageSize,
  });

  const handleSelectPage = (page) => setSelected(page);
  const handleNextPage = () => {
    if (selected < totalPages) setSelected(selected + 1);
  };
  const handlePrevPage = () => {
    if (selected > 1) setSelected(selected - 1);
  };

  const baseBtn =
    'inline-flex h-8 min-w-[32px] items-center justify-center rounded-md border border-slate-200 bg-white text-sm text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-900 disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div className="w-fit">
      <ul className="inline-flex items-center gap-1.5">
        <li>
          <button
            type="button"
            className={baseBtn}
            onClick={handlePrevPage}
            disabled={selected <= 1}
            aria-label="Previous page"
          >
            <IoIosArrowBack />
          </button>
        </li>
        {paginationRange.map((pageNumber, idx) => {
          if (pageNumber === DOTS) {
            return (
              <li key={`dots-${idx}`} className="px-2 text-slate-400">
                …
              </li>
            );
          }
          const isActive = selected === pageNumber;
          return (
            <li key={pageNumber}>
              <button
                type="button"
                className={`${baseBtn} px-3 ${
                  isActive ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700' : ''
                }`}
                onClick={() => handleSelectPage(pageNumber)}
              >
                {pageNumber}
              </button>
            </li>
          );
        })}
        <li>
          <button
            type="button"
            className={baseBtn}
            onClick={handleNextPage}
            disabled={selected >= totalPages}
            aria-label="Next page"
          >
            <IoIosArrowForward />
          </button>
        </li>
      </ul>
    </div>
  );
};

export default PaginationNav;
